var map = {
	"./cow.json": 6138,
	"./frogs.json": 3670,
	"./ic_home.json": 4871,
	"./ic_live.json": 4222,
	"./ic_lock.json": 7487,
	"./ic_search.json": 4316,
	"./plane.json": 7779,
	"./rooster.json": 8901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7032;